export { BenzingaLogo } from '../../logos/src/components/BenzingaLogo';
export type { BenzingaLogoProps } from '../../logos/src/components/BenzingaLogo';

export { BenzingaProLogo } from './components/BenzingaProLogo';
export type { BenzingaProLogoProps } from './components/BenzingaProLogo';

export { BenzingaCryptoLogo } from '../../logos/src/components/BenzingaCryptoLogo';
export type { BenzingaCryptoLogoProps } from '../../logos/src/components/BenzingaCryptoLogo';

export { BenzingaKoreaLogo } from '../../logos/src/components/BenzingaKoreaLogo';
export { BenzingaJapanLogo } from '../../logos/src/components/BenzingaJapanLogo';
export { BenzingaEsLogo } from '../../logos/src/components/BenzingaEsLogo';
export { BenzingaItLogo } from '../../logos/src/components/BenzingaItLogo';
export { BenzingaFrLogo } from '../../logos/src/components/BenzingaFrLogo';

export { MainLogo } from '../../logos/src/components/MainLogo';
export type { MainLogoVariant } from '../../logos/src/components/MainLogo';

export type LogoVariant = 'default' | 'crypto' | 'korea' | 'japan' | 'spain' | 'italy' | 'france' | 'india';
